import { SignUp } from '@clerk/react';

export default function Register() {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-bg p-5">
      <div
        className="pointer-events-none absolute inset-0 opacity-30"
        style={{ backgroundImage: 'linear-gradient(var(--color-border2) 1px, transparent 1px), linear-gradient(90deg, var(--color-border2) 1px, transparent 1px)', backgroundSize: '48px 48px' }}
      />
      <div className="pointer-events-none absolute left-1/2 top-0 h-[420px] w-[700px] -translate-x-1/2 rounded-full bg-accent/10 blur-3xl" />

      <div className="relative w-full max-w-[440px]">
        <div className="mb-8 flex items-center justify-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-[9px] bg-accent font-display text-base font-extrabold text-white shadow-[0_0_20px_rgba(245,47,85,.25)]">M</div>
          <span className="font-display text-xl font-extrabold text-ink">
            Mail<span className="text-accent">Cutover</span>
          </span>
        </div>

        <SignUp path="/register" routing="path" signInUrl="/login" fallbackRedirectUrl="/dashboard" />

        <p className="mt-6 text-center text-xs text-dim">
          MailCutover · Secure IMAP Migration Platform
        </p>
      </div>
    </div>
  );
}
